import { render, staticRenderFns } from "./PaymentCardPassBlock.vue?vue&type=template&id=7c28a2ce&scoped=true"
import script from "./PaymentCardPassBlock.vue?vue&type=script&lang=js"
export * from "./PaymentCardPassBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c28a2ce",
  null
  
)

export default component.exports